import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-20e9610c")

_pushScopeId("data-v-20e9610c")
const _hoisted_1 = { class: "pa-4 d-flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "iconfont iconreport-icon-dahan title-icon" }, null, -1)
const _hoisted_3 = { class: "px-4" }
const _hoisted_4 = { class: "d-flex px-6 sleep-curve-content pb-6" }
const _hoisted_5 = {
  class: "d-flex flex-column justify-center items-center",
  style: {"height":"100%"}
}
const _hoisted_6 = { class: "percentage" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "%", -1)
const _hoisted_8 = { class: "d-flex justify-center items-center label" }
const _hoisted_9 = {
  class: "d-flex flex-column justify-center items-center",
  style: {"height":"100%"}
}
const _hoisted_10 = { class: "percentage" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "%", -1)
const _hoisted_12 = { class: "d-flex justify-center items-center label" }
const _hoisted_13 = {
  class: "d-flex flex-column justify-center items-center",
  style: {"height":"100%"}
}
const _hoisted_14 = { class: "percentage" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "%", -1)
const _hoisted_16 = { class: "d-flex justify-center items-center label" }
const _hoisted_17 = {
  class: "d-flex flex-column justify-center items-center",
  style: {"height":"100%"}
}
const _hoisted_18 = { class: "percentage" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "%", -1)
const _hoisted_20 = { class: "d-flex justify-center items-center label" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_circle = _resolveComponent("van-circle")
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_cell_group = _resolveComponent("van-cell-group")
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock(_component_my_card, { class: "mt-4" }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("snoreLevel.snoreLevel")), 1 /* TEXT */)
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_my_card_body, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", {
              ref: $setup.setRef,
              style: {"height":"60vw","width":"100%"}
            }, null, 512)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", null, [
              _createVNode(_component_van_circle, {
                "current-rate": $props.snore_non_proportion,
                "layer-color": "rgba(255,255,255,.05)",
                color: "#6BFA94",
                size: "70",
                "stroke-width": "70"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("label", null, _toDisplayString($props.snore_non_proportion), 1),
                      _hoisted_7
                    ]),
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("snoreLevel.none")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["current-rate"])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_van_circle, {
                "current-rate": $props.snore_low_proportion,
                "layer-color": "rgba(255,255,255,.05)",
                color: "#6BFAE4",
                size: "70",
                "stroke-width": "70"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("label", null, _toDisplayString($props.snore_low_proportion), 1),
                      _hoisted_11
                    ]),
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("snoreLevel.light")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["current-rate"])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_van_circle, {
                "current-rate": $props.snore_mid_proportion,
                "layer-color": "rgba(255,255,255,.05)",
                color: "#6BC6FA",
                size: "70",
                "stroke-width": "70"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("label", null, _toDisplayString($props.snore_mid_proportion), 1),
                      _hoisted_15
                    ]),
                    _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("snoreLevel.medium")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["current-rate"])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_van_circle, {
                "current-rate": $props.snore_high_proportion,
                "layer-color": "rgba(255,255,255,.05)",
                color: "#DA6BFA",
                size: "70",
                "stroke-width": "70"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("label", null, _toDisplayString($props.snore_high_proportion), 1),
                      _hoisted_19
                    ]),
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("snoreLevel.heavy")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["current-rate"])
            ])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_van_cell_group, { border: false }, {
              default: _withId(() => [
                _createVNode(_component_van_cell, {
                  class: "cell-item",
                  title: _ctx.$t('snoreLevel.snoreNumber'),
                  value: $props.snore_number
                }, null, 8, ["title", "value"]),
                _createVNode(_component_van_cell, {
                  title: _ctx.$t('snoreLevel.snoreDuration'),
                  value: 
              `${$setup.duration($props.snore_duration).hours}H${
                $setup.duration($props.snore_duration).minutes
              }M`
            
                }, null, 8, ["title", "value"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})